import { Card } from './ui';

export function RiftCellsYoutubeAdminCards({ shortIdeas, learnings }: { shortIdeas: any[]; learnings: any[] }) {
  return <>
    <Card title="Shorts backlog">
      <p className="muted">Codzienny Short jest generowany z najlepszego dostępnego eksperymentu i trafia do tej samej kolejki renderującej.</p>
      <div className="table-wrap"><table><thead><tr><th>Title</th><th>Hook</th><th>Score</th></tr></thead><tbody>
        {shortIdeas.slice(0, 12).map((idea) => <tr key={idea.id}><td>{idea.title}</td><td>{idea.hook}</td><td>{idea.score}</td></tr>)}
        {!shortIdeas.length && <tr><td colSpan={3} className="muted">No Shorts ideas.</td></tr>}
      </tbody></table></div>
    </Card>
    <Card title="Learnings">
      <div className="table-wrap"><table><thead><tr><th>Pattern</th><th>Packages</th><th>Views</th><th>CTR</th><th>Recommendation</th></tr></thead><tbody>
        {learnings.map((row) => <tr key={row.pattern}><td>{row.pattern}</td><td>{row.packages}</td><td>{row.views}</td><td>{Number(row.ctr ?? 0).toFixed(2)}</td><td>{row.recommendation}</td></tr>)}
        {!learnings.length && <tr><td colSpan={5} className="muted">No learning signals yet.</td></tr>}
      </tbody></table></div>
    </Card>
  </>;
}
